module.exports = __webpack_public_path__ + "img/watch.4715bfeb.svg";